import React from "react";
import { Link } from "@/components/LocaleLink";
import { useLang } from "@/context/LanguageContext";
import { Home, Compass, Building2, Route as RouteIcon, Mail } from "lucide-react";

const NotFound = () => {
  const { lang } = useLang();
  const c = lang === "en"
    ? {
        code: "404",
        title: "We couldn't find that page",
        sub: "The page may have moved or no longer exists. Here are some useful places to continue.",
        links: [
          { to: "/", label: "Home", icon: Home },
          { to: "/indsatser", label: "Support pathways", icon: RouteIcon },
          { to: "/find-forloeb", label: "Find the right pathway", icon: Compass },
          { to: "/kommuner-og-kriminalforsorgen", label: "Municipalities & Probation Service", icon: Building2 },
          { to: "/kontakt", label: "Contact", icon: Mail },
        ],
      }
    : {
        code: "404",
        title: "Vi kunne ikke finde den side",
        sub: "Siden er måske flyttet eller findes ikke længere. Her er nogle nyttige steder at fortsætte.",
        links: [
          { to: "/", label: "Forside", icon: Home },
          { to: "/indsatser", label: "Indsatser og forløb", icon: RouteIcon },
          { to: "/find-forloeb", label: "Find det rette forløb", icon: Compass },
          { to: "/kommuner-og-kriminalforsorgen", label: "Kommuner og Kriminalforsorgen", icon: Building2 },
          { to: "/kontakt", label: "Kontakt", icon: Mail },
        ],
      };

  return (
    <section className="min-h-[70vh] flex items-center bg-[#F7F5F0]" data-testid="notfound-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-28 text-center">
        <p className="font-display text-7xl sm:text-8xl text-[#2D5A3F]">{c.code}</p>
        <h1 className="mt-4 font-display text-3xl sm:text-4xl text-[#1A2E24]">{c.title}</h1>
        <p className="mt-4 text-[#5C7567] max-w-xl mx-auto leading-relaxed">{c.sub}</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          {c.links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="inline-flex items-center gap-2 rounded-full border border-[#D3CEC0] bg-white/70 px-5 py-2.5 text-sm font-medium text-[#3B5245] hover:border-[#2D5A3F] hover:text-[#2D5A3F] transition-colors duration-300"
              data-testid={`notfound-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
            >
              <l.icon className="h-4 w-4" /> {l.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NotFound;
